import React from "react";
import axios from "axios";
import VerificationItem from "./VerificationItem";

const Kyc = ({ user, afterSubmit }) => {
  const changeAvatar = async (file) => {
    const { data } = await axios.put(`/api/users/${user.id}/avatar`, {
      file,
    });

    afterSubmit(data);
  };

  const handleIdVerification = async (file) => {
    const { data } = await axios.put(`/api/users/${user.id}/id-upload`, {
      file,
    });
    afterSubmit(data);
  };

  return (
    <div className="kyc">
      <div className="row m-5 g-3">
        <VerificationItem
          user={user}
          id="photo"
          file={user.avatar_file_id}
          onSave={changeAvatar}
          afterSubmit={afterSubmit}
          isVerified={user.is_avatar_verified}
        />
        <VerificationItem
          user={user}
          id="id"
          file={user.id_file_id}
          // ID documents are ownership-stamped and gated by the backend's
          // FileAccessPolicy — only this signed URL renders. (id_file_url is
          // absent on legacy unstamped files; those still work bare.)
          fileUrl={user.id_file_url}
          onSave={handleIdVerification}
          afterSubmit={afterSubmit}
          isVerified={user.is_id_verified}
          isAcceptable
        />
      </div>
    </div>
  );
};

export default Kyc;
